<template>
    <div
        v-click-outside-app="closeDatePicker"
        class="d-flex transactions-filter__datepicker"
        :class="{ 'transactions-filter__datepicker--active': isDatePickerOpen }"
    >
        <div
            @click="toggleDatePicker"
            class="transactions-filter__date-icon"
        >
            <span class="material-icons">
                date_range
            </span>
        </div>
        <div class="transactions-filter__datepicker-container">
            <span
                @click="toggleDatePicker"
                class="transactions-filter__date-between"
            >
                {{ getDateBetween }}
            </span>
            <transition name="fade">
                <div
                    v-if="isDatePickerOpen"
                    class="date-between-calender"
                >
                    <div class="d-flex flex-wrap flex-md-nowrap">
                        <div class="p-2 d-flex flex-row flex-md-column flex-wrap border-right">
                            <d-button
                                v-for="item in dateButtons"
                                squared
                                outline
                                :key="item.key"
                                :theme="isDateActive(item.start, item.end)"
                                class="mb-1 date-between-calender__button flex-grow-1 flex-grow-sm-0 mr-2 mr-md-0"
                                @click="changeDateRange(item.start, item.end)"
                            >
                                {{ item.label }}
                            </d-button>
                        </div>
                        <div>
                            <div class="p-2 d-flex flex-wrap flex-lg-nowrap">
                                <d-datepicker
                                    v-model="startDate"
                                    :highlighted="highlightedDates"
                                    :disabled-dates="disabledToDates"
                                    :inline="true"
                                />
                                <d-datepicker
                                    v-model="endDate"
                                    :highlighted="highlightedDates"
                                    :disabled-dates="disabledFromDates"
                                    :inline="true"
                                />
                            </div>
                            <div class="d-flex justify-content-end p-2">
                                <d-button
                                    @click="applyAndCloseDatePicker"
                                    theme="secondary"
                                    class="mb-0"
                                >
                                    Apply
                                </d-button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import DateButtons  from '@/models/transactions/dateButtons.model.js'
import DateHelper from '@/helpers/date'
import moment from 'moment'
import outsideClickMixin from '@/mixins/outsideClick.js'

export default {
    mixins: [outsideClickMixin],
    data() {
        return {
            startDate: new Date(DateHelper.getDateThisMonth()),
            endDate: new Date(DateHelper.getDateToday()),
            dateButtons: DateButtons,
            isDatePickerOpen: false,
        }
    },

    computed: {
        highlightedDates() {
            return {
                to: this.endDate,
                from: this.startDate,
            }
        },
        disabledFromDates() {
            return {
                to: this.startDate,

                customPredictor: function(date) {
                    const currentTime = new Date().getTime()

                    if (date.getTime() > currentTime) {
                        return true
                    }
                }
            }
        },
        disabledToDates() {
            return {
                from: this.endDate,
            }
        },
        getDateBetween() {
            return `${moment(this.startDate).format('YYYY-MM-DD')} - ${moment(this.endDate).format('YYYY-MM-DD')}`
        }
    },

    methods: {
        applyDateRange() {
            this.$emit('applyDateRangeFilter', {
                start: this.startDate,
                end: this.endDate
            })
            this.isDatePickerOpen = false
        },

        changeDateRange(start, end) {
            this.startDate = new Date(start)
            this.endDate = new Date(end)

            this.applyDateRange()
        },

        isDateActive(start, end) {
            const isStart = this.startDate.getTime() === new Date(start).getTime()
            const isEnd = this.endDate.getTime() === new Date(end).getTime()
            const active = isStart && isEnd

            return active ? 'primary' : 'secondary'
        },

        toggleDatePicker() {
            this.isDatePickerOpen = !this.isDatePickerOpen
        },

        applyAndCloseDatePicker() {
            this.applyDateRange(this.startDate, this.endDate)
            this.closeDatePicker()
        },

        closeDatePicker() {
            this.isDatePickerOpen = false
        }
    },

    created() {
        this.applyDateRange()
    }
}
</script>
